/* AST pink mark: draws the mark on when its heading scrolls into view, once per page load.
   Without this script, or with reduced motion, the mark is already fully drawn (assets/ast-mark.css). */
(function () {
  if (window.AstMark) return;
  window.AstMark = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var marks = document.querySelectorAll('.ast-pm[data-animate]');
  if (!marks.length) return;
  for (var i = 0; i < marks.length; i++) marks[i].classList.add('is-armed');
  void document.body.offsetWidth; /* the hidden state is laid out before the draw-on, so the transition runs */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      window.setTimeout(function () { el.classList.add('is-drawn'); }, 180);
    });
  }, { threshold: 0.5 });
  for (var j = 0; j < marks.length; j++) io.observe(marks[j]);
})();
